'use client';
import { useState } from 'react';
import { Button, Tooltip, TooltipTrigger } from 'react-aria-components';
import { t } from './translate';
export function OpenAPICopyButton(props) {
    var value = props.value, label = props.label, children = props.children, onPress = props.onPress, className = props.className, context = props.context, _a = props.withTooltip, withTooltip = _a === void 0 ? true : _a;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var handleCopy = function () {
        if (!value)
            return;
        navigator.clipboard.writeText(value).then(function () {
            setIsOpen(true);
            setCopied(true);
            setTimeout(function () {
                setCopied(false);
                setIsOpen(false);
            }, 2000);
        });
    };
    return (<TooltipTrigger isOpen={isOpen} onOpenChange={setIsOpen} isDisabled={!withTooltip} closeDelay={200} delay={200}>
            <Button type="button" preventFocusOnPress onPress={function (e) {
            handleCopy();
            onPress === null || onPress === void 0 ? void 0 : onPress(e);
        }} className={"openapi-copy-button ".concat(className)} {...props}>
                {children}
            </Button>

            <Tooltip isOpen={isOpen} onOpenChange={setIsOpen} placement="top" offset={4} className="openapi-tooltip">
                {copied
            ? t(context.translation, 'copied')
            : label || t(context.translation, 'copy_to_clipboard')}
            </Tooltip>
        </TooltipTrigger>);
}
